import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { SuccessProvider } from './SuccessContext';
import LandingPage from './LandingPage';  
import OnboardingFlow from './OnboardingFlow';
import OnlineCoachingSignup from './OnlineCoachingSignup';
import OnlinePowerliftingSignup from './OnlinePowerliftingSignup';
import OneTimeConsultationSignup from './OneTimeConsultationSignup';
import DrNoumanConsultationSignup from './DrNoumanConsultationSignup';
import BulkFlow from './bulk';
import WhatsApp from './whatsapp';

function App() {
  return (
    <SuccessProvider>
      <ReactLenis root>
        <Router>
          {/* WhatsApp Icon - Visible on all pages */}
          <WhatsApp />
          
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/onboarding" element={<OnboardingFlow />} />
            <Route path="/online-coaching-signup" element={<OnlineCoachingSignup />} />
            <Route path="/powerlifting-signup" element={<OnlinePowerliftingSignup />} />
            <Route path="/consultation-signup" element={<OneTimeConsultationSignup />} />
            <Route path="/dr-nouman-signup" element={<DrNoumanConsultationSignup />} />
            <Route path="/bulk" element={<BulkFlow />} />
          </Routes>
        </Router>
      </ReactLenis>
    </SuccessProvider>
  );
}

export default App;